import { SessionStorage } from "./sessionStorage";

class IsEditInfoOpenStorage extends SessionStorage {
	public constructor() {
		super({
			storageKey: "isEditOpen",
		});
	}
}

export const isEditInfoOpenStorage = new IsEditInfoOpenStorage();
